import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';
import { toast } from 'sonner';

const thunk = (name, fn) =>
  createAsyncThunk(name, async (arg, { rejectWithValue }) => {
    try { return await fn(arg); }
    catch (err) {
      const msg = err.response?.data?.message || err.message || 'Request failed';
      toast.error(msg);
      return rejectWithValue(msg);
    }
  });

export const fetchProducts = thunk('product/fetchAll', async (params = {}) => {
  const { data } = await api.get('Products', { params });
  return data.data;
});

export const createProduct = thunk('product/create', async (dto) => {
  const { data } = await api.post('Products', dto);
  toast.success('Product created');
  return data.data;
});

export const updateProduct = thunk('product/update', async ({ id, dto }) => {
  const { data } = await api.put(`Products/${id}`, dto);
  toast.success('Product updated');
  return data.data;
});

export const toggleProductStatus = thunk('product/toggleStatus', async ({ id, active }) => {
  await api.patch(`Products/${id}/status?active=${active}`);
  toast.success(`Product ${active ? 'activated' : 'deactivated'}`);
  return { id, active };
});

const productSlice = createSlice({
  name: 'product',
  initialState: { items: [], totalCount: 0, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchProducts.fulfilled, (s, a) => {
        s.loading = false;
        s.items = a.payload?.items || [];
        s.totalCount = a.payload?.totalCount || 0;
      })
      .addCase(fetchProducts.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(createProduct.fulfilled, (s, a) => { s.items = [a.payload, ...s.items]; s.totalCount += 1; })
      .addCase(updateProduct.fulfilled, (s, a) => {
        s.items = s.items.map((i) => (i.productId === a.payload.productId ? a.payload : i));
      })
      .addCase(toggleProductStatus.fulfilled, (s, a) => {
        s.items = s.items.map((i) =>
          i.productId === a.payload.id ? { ...i, isActive: a.payload.active } : i
        );
      });
  },
});

export default productSlice.reducer;